import * as React from 'react';
import UserNavigation from '../User/UserNavigation';
import MetaNavigationPartial from '../MetaNavigation/MetaNavigation';
import { Collapse, NavbarToggler } from 'reactstrap';
import { RouterState } from 'connected-react-router';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import './NavbarMain.scss';
import { userIsAdmin } from '../../Admin/utils';

export interface NavbarNavigationProps {
  location: RouterState['location'];
}

export class NavbarNavigationPartial extends React.Component<NavbarNavigationProps, any> {

  constructor(props: NavbarNavigationProps) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  componentDidUpdate (prevProps: NavbarNavigationProps) {
    const {
      location,
    } = this.props;

    if ((location && location.pathname) !== (prevProps.location && prevProps.location.pathname)) {
      this.setState({
        collapsed: true
      });
    }
  }

  public render() {
    return (
      <div className="partial-navbar-navigation">
          <div className={`${ this.state.collapsed ? 'side-nav position-absolute' : 'side-nav position-absolute slide-in'}`}>
            <div className={`${ this.state.collapsed ? 'inner' : 'inner slide-in'}`}>
              <NavbarToggler onClick={this.toggleNavbar} className={`${ this.state.collapsed ? 'mr-2 button-toggler' : 'mr-2 button-toggler slide-in'}`} />
              <Collapse isOpen={!this.state.collapsed} className="">
                <UserNavigation />
                <MetaNavigationPartial />
              </Collapse>
            </div>
          </div>
      </div>
    );
  }

  private toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }
}

export const NavbarNavigation = connect((state: GlobalPrivateState) => ({
  location: state.router.location,
}))(NavbarNavigationPartial);

export default NavbarNavigationPartial;